import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

function ModalCompilacao({ texto, show, setTextoModalCompilacao, setMostrarModalCompilacao }) {
  const handleClose = () => {
    setTextoModalCompilacao('');
    setMostrarModalCompilacao(false);
  };

  return (
    <div>
      <Modal show={show} size="lg" centered>
        <Modal.Dialog style={{margin:0}}>
          <Modal.Body>
            {texto}
          </Modal.Body>
          <Modal.Footer style={{flexDirection: "row-reverse"}}>
            <Button variant="dark" onClick={handleClose}>OK</Button>
          </Modal.Footer>
        </Modal.Dialog>
      </Modal>
    </div>
  );
}

export default ModalCompilacao;
